/**
 * O aviso dos backups, no painel.
 *
 * Existe por uma razão concreta: a cópia para fora do servidor esteve avariada
 * de 23/08 a 30/09/2026 — **911 execuções seguidas a falhar**, cada uma a
 * escrever a razão num ficheiro de registo que ninguém lia. Durante 38 dias
 * houve backups de hora a hora e um teste de restauro semanal a dizer
 * «restaurável», todos no mesmo disco da base que serviam para proteger.
 *
 * Por isso este componente **não mostra nada quando está tudo bem**. Um painel
 * com um sinal verde permanente é um sinal que se deixa de ver ao fim de uma
 * semana; o que se quer é que apareça alguma coisa no dia em que parar.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { ShieldAlert } from 'lucide-react';
import api from '../../utils/api';

const quando = (v) => (v
  ? new Date(v).toLocaleString('pt-PT', { timeZone: 'Africa/Luanda' })
  : 'nunca');

const SaudeBackups = () => {
  const [s, setS] = useState(null);

  const carregar = useCallback(() => {
    api.get('/admin/saude/backups').then((r) => setS(r.data)).catch(() => setS(null));
  }, []);
  useEffect(() => {
    carregar();
    // De dez em dez minutos. O backup é de hora a hora, por isso não há nada
    // a ganhar em perguntar mais vezes.
    const t = setInterval(carregar, 10 * 60 * 1000);
    return () => clearInterval(t);
  }, [carregar]);

  if (!s || s.ok) return null;

  const problemas = s.linhas.filter((l) => !l.ok);

  return (
    <div className="p-4 rounded-xl border border-red-800 bg-red-950/40 space-y-2">
      <div className="flex items-center gap-2 text-red-300 font-bold">
        <ShieldAlert className="w-5 h-5" />
        {problemas.length === 1 ? 'Um backup parado' : `${problemas.length} backups parados`}
      </div>

      <ul className="space-y-1.5 text-sm">
        {problemas.map((l) => (
          <li key={l.tipo}>
            <span className="text-slate-200 font-semibold">{l.rotulo}</span>
            <span className="text-slate-400">
              {' — '}
              {l.ultimo_sucesso
                ? `último bom há ${l.horas_desde}h (${quando(l.ultimo_sucesso)})`
                : 'nunca correu com sucesso'}
            </span>
            {/* A razão da última falha, quando é mais recente do que o último
                sucesso. Sem ela, quem lê sabe que parou e não sabe porquê. */}
            {l.falha_recente?.detalhe && (
              <div className="text-xs text-red-300 mt-0.5">{l.falha_recente.detalhe}</div>
            )}
          </li>
        ))}
      </ul>

      <p className="text-xs text-slate-400">
        Os registos estão em <code className="text-slate-300">/var/log/dozy-backup.log</code> no
        servidor. Enquanto a cópia para fora estiver parada, os backups existem apenas
        no mesmo disco da base de dados.
      </p>
    </div>
  );
};

export default SaudeBackups;
